import { type FC } from 'react';
import { NudosGenericModal, NudosModalContent } from '../../../../../../../components/NudosComponents';
import { IProductInfo } from '../../../../../../../types/products';
import { IlogisticServiceDetailsOrganizationData, IproductLocationData } from '../../../../../../../types/services';
import ChangeToolsModalCustomComponent from './ChangeToolsModalCustomComponent/ChangeToolsModalCustomComponent';
import './ChangeToolsModal.scss';

interface ChangeToolsModalProps {
  updateDataCallback: () => Promise<void>;
  changeShowModal?: () => void;
  productInfo?: IProductInfo;
  organizationInfo?: IlogisticServiceDetailsOrganizationData;
  originalLocation?: IproductLocationData | null;
}

const ChangeToolsModal: FC<ChangeToolsModalProps> = ({
  updateDataCallback,
  changeShowModal,
  productInfo,
  organizationInfo,
  originalLocation
}) => {
  const closeModal = () => changeShowModal?.();

  if (!productInfo || !organizationInfo) return null;
  return (
    <NudosGenericModal
      closeModalCallback={closeModal}
      modalContent={
        <NudosModalContent
          customWidth="580px"
          customHeight="420px"
          modalContentTitle="Cambiar la herramienta"
          toCloseModal={closeModal}
          noScroll
          CustomModalComponent={
            <ChangeToolsModalCustomComponent
              updateDataCallback={updateDataCallback}
              productInfo={productInfo}
              organizationInfo={organizationInfo}
              originalLocation={originalLocation}
            />
          }
        />
      }
    />
  );
};

export default ChangeToolsModal;
